import { Container } from "@chakra-ui/react";
import { DebugTable } from "./DebugTable";

export const Developer = () => {
  return (
    <Container centerContent>
      <DebugTable />
    </Container>
  );
};
